import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "vcm_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Streaming helper using fetch + ReadableStream for SSE
export async function streamLLM(endpoint, body, { onDelta, onDone, onError }) {
  const token = getToken();
  try {
    const res = await fetch(`${API}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: JSON.stringify(body),
    });
    if (!res.ok || !res.body) {
      const txt = await res.text().catch(() => "");
      if (res.status === 402) {
        onError?.("QUOTA_EXCEEDED");
      } else {
        onError?.(`HTTP ${res.status}: ${txt}`);
      }
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop() || "";
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith("data:")) continue;
        const json = line.slice(5).trim();
        if (!json) continue;
        try {
          const obj = JSON.parse(json);
          if (obj.delta) onDelta?.(obj.delta);
          else if (obj.done) onDone?.();
          else if (obj.error) onError?.(obj.error);
        } catch (e) {
          // ignore malformed chunk
        }
      }
    }
    onDone?.();
  } catch (e) {
    onError?.(e.message || String(e));
  }
}
